module.exports = __webpack_public_path__ + "static/media/roxy2.405287be.jpg";